import { Typography } from '@mui/material';
import { PdfViewer } from '@shared/components/PdfViewer';
import { Modal } from '@shared/components/modals/Modal';
import { RelativeWrapper } from '@shared/styledComponents';
import { LocalTabContent } from '@styles/CommonStyles';

interface IDealSheetSummaryModalProps {
  open: boolean;
  handleClose: () => void;
  fileContents: string;
}

export const DealSheetSummaryModal =  ({ open, handleClose, fileContents }: IDealSheetSummaryModalProps) =>
{
    
  return (<Modal
    open={open}
    title="Deal Summary"
    dialogWidth="60%"
    hideBackdrop={true}
    onClose={handleClose}
  >
    <RelativeWrapper>
      <LocalTabContent>
        { fileContents  ? <PdfViewer fileSource={fileContents} /> :
          <Typography fontWeight='bold' justifyContent='center'>
            No Document Found
          </Typography>
        }
      </LocalTabContent>
    </RelativeWrapper>

  </Modal>);
};

